import TomSelect from "tom-select";
import LocalizationUtility from "./LocalizationUtility";

export default class GavSearch {
    constructor(form) {
        this.language = document.querySelector('html').lang;
        this.LocalizationUtility = undefined;
        this.form = form;
        this.formContainer = this.form.closest("section.gav-search");
        this.resultField = this.formContainer.querySelector('.gav-search-form-list');
        this.formAction = undefined;
        this.apiKey = undefined;
        this.apiUrl = undefined;

        // user selection
        this.jobtitleId = undefined;
        this.jobtitle = undefined;
        this.zipcode = undefined;
        this.temporary = undefined;
        this.contractNumber = undefined;
        this.versionNumber = undefined;
        this.editionId = undefined;
        this.contractName = undefined;
        this.filename = undefined;
        this.fileId = undefined;
        if(this.formContainer) {
            this.initializeForm().then(() => {
            });
        }
    }

    async initializeForm() {
        this.formAction = this.formContainer.querySelector('form.gav-search').action;
        this.apiUrl = this.formContainer.dataset.apiurl;
        this.apiKey = this.formContainer.dataset.apikey;

        this.localizationNum = this.formContainer.dataset.localizationnum;
        await this.initLocalization(this.localizationNum);

        const jobtitlesEndpoint = this.apiUrl + '/api/jobtitles?language='+this.language+'-CH&query=';
        const fieldJobtitle = this.form.querySelector('#jobtitle');
        let selectField = this.initializeJobTitle(fieldJobtitle, jobtitlesEndpoint, this.apiKey);
        // Refresh selected jobtitle on change
        selectField.on('change', (value) => {
            this.jobtitleId = value;
            this.jobtitle = fieldJobtitle.options[fieldJobtitle.selectedIndex].text;
        });

        // Process first Form step
        const submitGavsearch = this.form.querySelector('#submit-gav-search');

        /*let that = this;*/
        submitGavsearch.addEventListener('click', (e) => {
            e.preventDefault();
            let valid = this.form.checkValidity();
            if(valid) {
                let formdata = new FormData(this.form);
                this.getContractList(formdata);
            } else {
                this.form.querySelectorAll('input,select').forEach((input) => {
                   if(!input.checkValidity()) {
                       input.classList.add('is-invalid');
                   } else {
                       input.classList.remove('is-invalid');
                   }
                });

            }
        });

        this.resetFormValidationListener();

    }

    resetFormValidationListener() {
        this.form.querySelectorAll('input,select').forEach((input) => {
            input.addEventListener('change', (e) => {
                if(input.checkValidity()) {
                    input.classList.remove('is-invalid');
                }
            });
        });
    }

    async initLocalization(localizationNum) {
        let stringUrl = window.location.origin + window.location.pathname + '?type=' + localizationNum;
        let requestUrl = new URL(stringUrl);
        this.LocalizationUtility = new LocalizationUtility(requestUrl);
        await this.LocalizationUtility.init();
    }


    initializeJobTitle(input, endpoint, apiKey) {
        let that = this;

        let renderOptions= {};
        renderOptions = {
            no_results: function( data, escape ){
                return '<div class="no-results">' + that.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.no-results')+ '</div>';
            }
        }

        return new TomSelect(input, {
            valueField: 'id',
            labelField: 'value',
            create: false,
            searchField: ['value', 'id'],
            maxOptions: 999999,
            maxItems: 1,
            // minimum query length
            shouldLoad: function (query) {
                return query.length > 2;
            },
            // fetch remote data
            load: function (query, callback) {
                let url = endpoint + encodeURIComponent(query);
                /*url = '/fileadmin/Api/jobtitles.json';*/
                let requestHeaders = new Headers({
                    "Unia-Api-Key": apiKey,
                    'Content-Type': 'application/json',
                    'Quack': 'https:staging.unia.ch'
                });
                fetch(url, {
                    method: 'GET',
                    mode: 'cors',
                    headers: requestHeaders
                })
                    .then(response => response.json())
                    .then(json => {
                        callback(json.currentItems)
                    }).catch((e) => {
                    console.log('fetch error', e)
                    callback();
                });

            },
            render: renderOptions
        });
    }

    getContractList(data) {

        this.jobtitleId = data.get('tx_frpuniagav_gavsearch[jobtitle]');
        this.zipcode = data.get('tx_frpuniagav_gavsearch[zipcode]');
        this.temporary = data.get('tx_frpuniagav_gavsearch[temporary]');

        let endpoint = `/api/contractsearch?JobTitleId=${this.jobtitleId}&Plz=${this.zipcode}&TemporaryWork=${this.temporary}&language=${this.language}-CH`;
        let url = this.apiUrl + endpoint;
        let requestHeaders = new Headers({
            "Unia-Api-Key": this.apiKey,
            'Content-Type': 'application/json'
        });
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: requestHeaders
        })
            .then(response => response.json())
            .then(json => {
                if(json.success !== false) {
                    if(json.currentItems.length > 0) {
                        this.showContractList(json);
                    } else {
                        this.showError('notfound');
                    }
                } else {
                    if(json.message == 'could not load contracts') {
                        this.showError('notfound');
                    } else {
                        this.showError('generic');
                    }
                }
            }).catch((e)=>{
            console.log('fetch error', e);
        });


    }

    getRedirectUrl() {
        let urlstring = this.form.dataset.redirecturi;
        urlstring = urlstring.replace('FRP_REPLACE', this.zipcode);
        let url = new URL(urlstring);
        url.searchParams.delete('cHash');
        return url.toString();
    }

    showError(modality) {
        let html = '';
        switch (modality) {
            case 'notfound':
                html = '<p class="mt3 form-error">'
                    + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showerror.notfound.part1')
                    + ' <a href="'+ this.getRedirectUrl() +'">'
                    + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showerror.notfound.part2')
                    +'</a>.</p><p class="form-error">'
                    + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showerror.notfound.part3')
                    +'</p>';
                break;
            case 'generic':
                html = '<p class="mt-3 form-error">'
                + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showerror.generic.part1')
                + ' <a href="'+this.getRedirectUrl()+'">' +
                + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showerror.generic.part2')
                + '</a>.</p>';
        }

        this.resultField.innerHTML = html;

        //show result wrap
        let resultInnerWrap = this.resultField.closest('.gav-search-form-message-wrap');
        resultInnerWrap.classList.add('active');
        resultInnerWrap.closest('.gav-search-form-message').classList.add('active');

        this.appendListenerToCloseButton(resultInnerWrap);
    }
    showContractList(data) {
        let html = '<h3>' + this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showcontractlist.title') + '</h3><div class="gav-list">';

        if(this.temporary === 'true') {
            html = html + '<p class="mt-3 small">'+ this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showcontractlist.temp-info') +' <a href="https://www.tempservice.ch/de/tempdata/index.php" class="small" target="_blank">'+ this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showcontractlist.temp-info.linktext') +'</a> '+this.LocalizationUtility.translate('javascript.frp_unia_gav.gavsearch.showcontractlist.temp-info.end')+'</p>';
        }
        html = html + '<ul class="list-unstyled mt-3 contract-list">';

        data.currentItems.forEach((e, i) => {
            html = html + "<li class='list-item'>"
                + "<a class='contract' href='#' data-contractnumber='" + e.contractNumber
                                            + "' data-versionnumber='" + e.versionNumber
                                            + "' data-editionid='" + e.editionId
                                            + "' data-contractname='" + e.contractName
                                            + "' data-filename='" + e.fileName
                                            + "' data-fileId='" + e.fileId
                                            + "'>"
                + "<span class='icon-chevron-large-right pe-2'></span><span>" + e.contractName + "</span></a>"
                + "</li>";
        });
        html = html + '</ul>';

        html = html + '</div>';

        this.resultField.innerHTML = html;

        //show result wrap
        let resultInnerWrap = this.resultField.closest('.gav-search-form-message-wrap');
        resultInnerWrap.classList.add('active');
        resultInnerWrap.closest('.gav-search-form-message').classList.add('active');

        this.appendListenerToCloseButton(resultInnerWrap);

        //add clicklistener on links
        this.initializeContractSelection();
    }

    appendListenerToCloseButton(resultInnerWrap) {
        let closeButton = resultInnerWrap.querySelector('.message-close');
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            resultInnerWrap.classList.remove('active');
            resultInnerWrap.closest('.gav-search-form-message').classList.remove('active');
        });
    }

    initializeContractSelection() {
        let contracts = this.form.querySelectorAll('.contract');

        let that = this;
        contracts.forEach(function(c) {
            c.addEventListener('click', function (e) {
                e.preventDefault();
                that.contractNumber = e.target.parentElement.dataset.contractnumber;
                that.versionNumber = e.target.parentElement.dataset.versionnumber;
                that.editionId = e.target.parentElement.dataset.editionid;
                that.contractName = e.target.parentElement.dataset.contractname;
                that.filename = e.target.parentElement.dataset.filename;
                that.fileId = e.target.parentElement.dataset.fileid;

                that.validate();

            })
        })
    }

    validate() {
        if(true) {
            // @todo add validation
            this.addFormdata();
        }
    }

    addFormdata() {
        let formData = new FormData(this.form);

        formData.set('jobtitleValue', this.jobtitle);
        formData.set('zipcodeValue', this.zipcode);
        formData.set('temporaryValue', this.temporary);
        formData.set('contractNumberValue', this.contractNumber);
        formData.set('versionNumberValue', this.versionNumber);
        formData.set('editionIdValue', this.editionId);
        formData.set('contractNameValue', this.contractName);
        formData.set('fileNameValue', this.filename);
        formData.set('fileIdValue', this.fileId);
        formData.forEach((value, name) => {
            let input = this.form.querySelector(`[name="${name}"]`);
            input.setAttribute("value", value);
        });

        //get all values from this.form
        this.form.submit();
    }
}
